import React from 'react'
import { string, bool, func, arrayOf } from 'prop-types'

// helpers
import classNames from 'src/common/helpers/class-names'
import { makeSentenceCase } from 'shared/util/string'

import Icon from 'src/common/components/icon'

import { componentsTags } from './componentsTags'
import PromoText from './promoText'

import './_style.scss'

const blk = 'co-product'

const Promo = (props) => {
  const {
    className,
    show,
    isBundle,
    onClick,
    promoDetail,
    promoDetailFull,
    url,
    categoryId,
    type,
    isLinkSave,
    isMeatSticker,
    itemName,
    mods: promoMods,
    shouldHidePrice,
  } = props

  if (!show && !isBundle) return null

  const getPromoType = () => {
    if (isBundle) return 'bundle'

    if (isLinkSave && !isMeatSticker) return 'linksave'

    return type.toLowerCase()
  }

  const getEDLPLabel = () =>
    (getPromoType() === 'asda price'
      ? `Low price every day, browse similar products to ${itemName}`
      : '')

  const getPromoConfig = () => {
    switch (getPromoType()) {
      case 'bundle':
        return {
          name: 'Bundle',
          title: 'Bundle',
          mods: ['bundle'],
          url,
        }
      case 'linksave':
        return {
          name: makeSentenceCase(promoDetailFull || promoDetail),
          title: promoDetailFull || promoDetail,
          mods: ['link-save'],
          url,
        }
      case 'rollback':
        return {
          name: 'RollBack',
          title: 'RollBack',
          mods: ['rollback'],
          url,
        }
      case 'new':
        return {
          name: 'New',
          title: 'New',
          mods: ['new'],
          url,
        }
      case 'asda price':
        return {
          name: <Icon name='price-every-day' asBrand />,
          title: `${getEDLPLabel()}`,
          mods: ['staying-back'],
          url,
        }
      case 'sale':
        const iconMods = []
        if ((url || categoryId)) iconMods.push('link')
        return {
          name: (
            <Icon
              className={classNames({ blk, elt: 'sale-icon', mods: iconMods })}
              name='sale'
              color='white'
              size='large'
            />
          ),
          title: 'Sale',
          mods: ['sale'],
          url,
        }
      case 'no promo':
      default:
        return {
          name: 'no-promo',
        }
    }
  }

  const {
    name, mods, url: promoUrl, title,
  } = getPromoConfig()

  if (name === 'no-promo' || shouldHidePrice) return null

  const tag = promoUrl ? 'link' : 'span'

  const handleClick = tag === 'link' ? onClick : null
  const TagComponent = componentsTags[tag]

  const tagClass = classNames({
    className,
    blk,
    elt: 'promo',
    mods: [...mods, ...promoMods],
  })

  return (
    <TagComponent
      ariaLabel={getEDLPLabel()}
      data-auto-id='secondaryPromoBanner'
      className={tagClass}
      to={promoUrl}
      title={title}
      onClick={handleClick}
    >
      <PromoText tag={tag}>{name}</PromoText>
    </TagComponent>
  )
}

Promo.propTypes = {
  className: string,
  show: bool,
  isBundle: bool,
  onClick: func,
  promoDetail: string,
  promoDetailFull: string,
  url: string,
  categoryId: string,
  type: string,
  isLinkSave: bool,
  isMeatSticker: bool,
  itemName: string,
  mods: arrayOf(string),
  shouldHidePrice: bool,
}

Promo.defaultProps = {
  className: '',
  show: true,
  isBundle: false,
  onClick() {},
  promoDetail: '',
  promoDetailFull: '',
  url: '',
  categoryId: null,
  type: '',
  isLinkSave: false,
  isMeatSticker: false,
  itemName: '',
  mods: [],
  shouldHidePrice: false,
}

export { Promo as default, PromoText }



// WEBPACK FOOTER //
// ./shared/interim/product/promo/index.js